import React from "react";
import {Form} from "antd";

import {LabelAttribute} from "../label-attribute";
import {DisabledAttribute} from "../disabled-attribute";
import {RequiredAttribute} from "../required-attribute";
import {useFocusedNode} from "../../model/editor";
import {FormControlSourceNode} from "../../model/schemaTypes";

/**
 * FormControl type-specific form to adjust attributes.
 */
export const ZipCodeFieldForm = () => {
  const node = useFocusedNode() as FormControlSourceNode;

  return (
    <Form
      key={node.id}
      initialValues={{
        label: node?.reference?.translationKey,
      }}
    >
      <LabelAttribute />
      <DisabledAttribute />
      <RequiredAttribute />
    </Form>
  );
};
